var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoMas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 0C42.8758 0 44.1953 0.546539 45.1681 1.51938C46.141 2.49223 46.6875 3.81169 46.6875 5.1875V36.3125H77.8125C79.1883 36.3125 80.5078 36.859 81.4806 37.8319C82.4535 38.8047 83 40.1242 83 41.5C83 42.8758 82.4535 44.1953 81.4806 45.1681C80.5078 46.141 79.1883 46.6875 77.8125 46.6875H46.6875V77.8125C46.6875 79.1883 46.141 80.5078 45.1681 81.4806C44.1953 82.4535 42.8758 83 41.5 83C40.1242 83 38.8047 82.4535 37.8319 81.4806C36.859 80.5078 36.3125 79.1883 36.3125 77.8125V46.6875H5.1875C3.81169 46.6875 2.49223 46.141 1.51938 45.1681C0.546539 44.1953 0 42.8758 0 41.5C0 40.1242 0.546539 38.8047 1.51938 37.8319C2.49223 36.859 3.81169 36.3125 5.1875 36.3125H36.3125V5.1875C36.3125 3.81169 36.859 2.49223 37.8319 1.51938C38.8047 0.546539 40.1242 0 41.5 0V0Z",
    fill: "#F0F0EE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoMas);
export default __webpack_public_path__ + "static/media/icono_mas.a409be8847636ba0fd3776684d473b82.svg";
export { ForwardRef as ReactComponent };